import {
  Body2,
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
  makeStyles,
} from "@fluentui/react-components";
import React, { Dispatch, SetStateAction, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { overtimeAssigments } from "../../services";
import { AppButton, AppDateSelect } from "../common";
import appErrorToast from "../common/AppErrorToast";
import { useState } from "react";

interface IChangeRealizationDateDialogProps {
  open: boolean;
  currentRealizationDate?: string;
  setOpen: Dispatch<SetStateAction<boolean>>;
  setReload: Dispatch<SetStateAction<boolean>>;
  reload: boolean;
}

type Inputs = {
  realizationDate: string;
};

const useStyles = makeStyles({
  formContainer: {
    display: "flex",
    flexDirection: "column",
  },
  input: {
    marginBottom: "1rem",
    width: "100%",
  },
  hint: {
    marginBottom: "1rem",
  },
});

const ChangeRealizationDateDialog: React.FC<IChangeRealizationDateDialogProps> = ({
  open,
  currentRealizationDate,
  setOpen,
  setReload,
  reload,
}) => {
  const styles = useStyles();
  const { id } = useParams<{ id: string }>();
  const [isLoading, setIsLoading] = useState(false);
  const { register, handleSubmit, reset } = useForm<Inputs>();

  useEffect(() => {
    if (open) {
      reset({ realizationDate: currentRealizationDate });
    }
  }, [open, currentRealizationDate, reset]);

  const handleFormSubmit = async (data: Inputs) => {
    if (!data.realizationDate) {
      appErrorToast("Podaj datę realizacji");
      return;
    }

    setIsLoading(true);
    try {
      await overtimeAssigments.changeRealizationDate(id, data.realizationDate);
      setOpen(false);
      setReload(!reload);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(_, data) => setOpen(data.open)}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>Zmień datę realizacji</DialogTitle>
          <DialogContent>
            <form className={styles.formContainer}>
              <Body2 className={styles.hint}>
                Zmiana daty realizacji przeniesie rozliczone godziny do miesiąca nowej
                daty i przeliczy salda nadgodzin.
              </Body2>
              <AppDateSelect
                label="Data realizacji"
                className={styles.input}
                formHandler={register("realizationDate", { required: true })}
                defaultValue={currentRealizationDate}
              />
            </form>
          </DialogContent>
          <DialogActions>
            <DialogTrigger disableButtonEnhancement>
              <Button appearance="secondary">Anuluj</Button>
            </DialogTrigger>
            <AppButton
              text="Zapisz"
              disabled={isLoading}
              appearance="primary"
              onClick={handleSubmit((data) => handleFormSubmit(data))}
            />
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default ChangeRealizationDateDialog;
